

















import {Component, Vue, Prop} from 'vue-property-decorator';
import {Route} from 'vue-router';
import FlowReportFilters from '@/features/reports/components/flows/FlowReportFilters.vue';
import DateRangeFilter from '@/features/reports/components/DateRangeFilter.vue';
import ReportDownloader from '@/features/reports/components/ReportDownloader.vue';
import UsageDateRangeFilter from '@/features/reports/components/usage/UsageDateRangeFilter.vue';

@Component({
	components: {
		FlowReportFilters,
		DateRangeFilter,
		UsageDateRangeFilter,
		ReportDownloader
	}
})
export default class ReportFilters extends Vue {
	@Prop() public activeRoute: Route;

	public get isFlowReportDisplayed() {
		return this.activeRoute && this.activeRoute.name === 'reports-flows';
	}

	public get isIntentsReportDisplayed() {
		return this.activeRoute && this.activeRoute.name === 'reports-intents';
	}

	public get isUsageReportDisplayed() {
		return this.activeRoute && this.activeRoute.name === 'reports-usage';
	}
}
